<template>
  <div class="iphone-container">
    <div class="background-image"></div>
    <div class="gradient-overlay"></div>
    <div class="main-content">
      <h1 class="logo">LERA</h1>
      <p class="description">成品装货登记系统</p>
      <div class="login-status">
        <div v-if="isLoading" class="loading-container">
          <div class="spinner"></div>
          <p>{{ loadingText }}</p>
        </div>
        <div v-if="errorMessage" class="error-container">
          <p class="error-message">{{ errorMessage }}</p>
          <button class="retry-button" @click="handleWeChatAuth">
            点击重试
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {wechatLogin, queryLatestShipment} from '@/api/wx';

export default {
  name: 'AuthPage',
  data() {
    return {
      isLoading: true,
      errorMessage: '',
      loadingText: '正在自动登录...',
    };
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') {
      this.mockLogin();
      return;
    }
    this.handleWeChatAuth();
  },
  methods: {
    handleWeChatAuth() {
      sessionStorage.removeItem('latestShipment');
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      if (code) {
        this.loginWithCode(code);
      } else {
        this.redirectToWeChat();
      }
    },
    redirectToWeChat() {
      const appId = 'wxe498b2b6503aac21';
      const redirectUri = encodeURIComponent(
          window.location.href.split('?')[0]
      );
      const scope = 'snsapi_base';
      const state = 'LERA_AUTH';
      const wechatAuthUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
      window.location.href = wechatAuthUrl;
    },
    async loginWithCode(code) {
      this.isLoading = true;
      this.errorMessage = '';
      this.loadingText = '正在自动登录...';
      try {
        const authInfo = await wechatLogin(code);
        localStorage.setItem('user-openid', authInfo.openid);
        localStorage.setItem('wechat-auth-info', JSON.stringify(authInfo));
        this.loadingText = '正在查询历史状态...';
        const shipmentStatus = await queryLatestShipment(authInfo.openid);

        if (
            shipmentStatus &&
            shipmentStatus.status !== null &&
            shipmentStatus.status !== 4
        ) {
          sessionStorage.setItem(
              'latestShipment',
              JSON.stringify(shipmentStatus)
          );
          this.$router.push({name: 'StatusPage'});
        } else {
          const queryParams = {};
          if (shipmentStatus && shipmentStatus.driverName) {
            queryParams.driverName = shipmentStatus.driverName;
          }
          if (shipmentStatus && shipmentStatus.driverPhone) {
            queryParams.driverPhone = shipmentStatus.driverPhone;
          }
          if (shipmentStatus && shipmentStatus.bindInfoId) {
            queryParams.bindInfoId = shipmentStatus.bindInfoId;
          }
          this.$router.push({name: 'HomePage', query: queryParams});
        }

      } catch (error) {
        this.errorMessage = `处理失败：${error.message}。请刷新页面重试。`;
        this.isLoading = false;
      }
    },
    async mockLogin() {
      // 简单跳转到 HomePage
      this.$router.push({
        name: 'HomePage',
        query: {driverName: '模拟司机', driverPhone: '13800138000'},
      });
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  font-family: 'Barlow', sans-serif;
}

.iphone-container {
  width: 100%;
  max-width: 480px;
  height: 100vh;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  background-color: #d6e4ee;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 40%;
  background-image: url('@/assets/lera.png');
  background-size: cover;
  background-position: center;
  z-index: 0;
}

.gradient-overlay {
  position: absolute;
  top: 40vh;
  left: 0;
  width: 100%;
  height: 70vh;
  background: linear-gradient(180deg, rgba(0, 54, 90, 1) 20%, rgba(199, 219, 233, 1) 45%, rgba(214, 228, 238, 1) 100%);
  z-index: 1;
}

.main-content {
  position: relative;
  z-index: 2;
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  color: white;
  text-align: center;
}

.logo {
  font-size: 60px;
  font-weight: 600;
  margin-bottom: 0;
}

.description {
  font-size: 18px;
  color: #f0f0f0;
  margin-top: -10px;
  margin-bottom: 40px;
}

.login-status {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  color: #f0f0f0;
}

.spinner {
  width: 32px;
  height: 32px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  width: 100%;
}

.error-message {
  color: #ffdddd;
  font-size: 14px;
}

.retry-button {
  width: 100%;
  padding: 16px 40px;
  background-color: #00416b;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
  transition: background-color 0.3s;
}

.retry-button:hover {
  background-color: #005a8a;
}
</style>